<script setup>
import navItems from '@/navigation/horizontal'
import { computed, onMounted, watch } from 'vue'
import { useReservationsStore } from '@/stores/reservations'
import { useI18n } from 'vue-i18n'

// Components
import Footer from '@/layouts/components/Footer.vue'
import { HorizontalNavLayout } from '@layouts'

const { t } = useI18n()
const { isTabletMode, loadTabletMode } = useTabletMode()
const userStore = useUserStore()
const reservationsStore = useReservationsStore()

const filteredNavItems = computed(() => {
  let items = navItems

  if (!isTabletMode.value) {
    items = items.filter(item => {
      const routeName = typeof item.to === 'object' ? item.to.name : item.to
      return routeName !== 'kds'
    })
  } else {
    items = items.filter(item => {
      const allowedRoutes = ['orders', 'order-type', 'tables', 'settings']
      const routeName = typeof item.to === 'object' ? item.to.name : item.to
      return allowedRoutes.includes(routeName)
    })
  }

  return items.map(item => {
    const routeName = typeof item.to === 'object' ? item.to.name : item.to
    const translatedItem = {
      ...item,
      title: t(item.title),
    }
    if (routeName === 'reservations' && reservationsStore.pendingCount > 0) {
      return {
        ...translatedItem,
        badgeContent: reservationsStore.pendingCount > 99 ? '99+' : String(reservationsStore.pendingCount),
        badgeClass: 'bg-warning',
      }
    }
    return translatedItem
  })
})

watch(() => userStore.activeBusinessId, async (businessId) => {
  if (businessId) {
    await reservationsStore.fetchPendingCount(businessId)
  }
}, { immediate: true })

onMounted(async () => {
  await loadTabletMode()
  if (userStore.activeBusinessId) {
    await reservationsStore.fetchPendingCount(userStore.activeBusinessId)
  }
})
</script>

<template>
  <HorizontalNavLayout :nav-items="filteredNavItems">
    <!-- 👉 Pages -->
    <slot/>

    <!-- 👉 Footer -->
    <template #footer>
      <Footer/>
    </template>

  </HorizontalNavLayout>
</template>
